import { useQuery } from "react-query";

import { staticDropdownValuesService } from "services";

const useFeeProgramsQuery = () =>
	useQuery("feePrograms", staticDropdownValuesService.getFeePrograms);

export default useFeeProgramsQuery;
